















































































































































import axios from 'axios';
import Component from 'vue-class-component';
import { Ref, Watch } from 'vue-property-decorator';

import {
  CategorizationStatus,
  Coins,
  Contact,
  ReconciliationStatus,
  Transaction,
  TransactionsResult,
  TxnType,
  Wallet,
} from '@/api-svc-types';
import { BaseVue } from '@/BaseVue';
import UiButton from '@/components/ui/UiButton.vue';
import UiDatePicker from '@/components/ui/UiDatePicker.vue';
import UiDropdown from '@/components/ui/UiDropdown.vue';
import UiLoading from '@/components/ui/UiLoading.vue';
import UiModal from '@/components/ui/UiModal.vue';
import UiRadioGroup from '@/components/ui/UiRadioGroup.vue';
import UiSelect from '@/components/ui/UiSelect.vue';
import UiTextEdit from '@/components/ui/UiTextEdit.vue';
import UiTooltip from '@/components/ui/UiTooltip.vue';
import { RegisterQuery } from '@/queries/registerQuery';
import { stringifyError } from '@/utils/error';
import { isDefined } from '@/utils/guards';

import { baConfig } from '../../../config';

@Component({
  components: {
    UiModal,
    UiButton,
    UiDropdown,
    UiTooltip,
    UiLoading,
    UiSelect,
    UiRadioGroup,
    UiTextEdit,
    UiDatePicker,
  },
})
export default class Explore extends BaseVue {
  reconciliations?: { key: string; value: string }[] = [];
  runs?: any[] = [];
  rows?: any[] = [];
  runId?: string;

  public reconciliation: string | null = null;

  public showRuns = true;

  public get headers() {
    if (this.showRuns) {
      return Object.values(this.runsColumns).map((x) => x.heading);
    } else {
      return Object.values(this.rowsColumns).map((x) => x.heading);
    }
  }

  public showNewDialog = false;

  public runsColumns = {
    id: { heading: 'Id', size: 1 },
    date: { heading: 'Date', size: 1 },
    status: { heading: 'Status', size: 1 },
    actions: { heading: '', size: 1 },
  };

  public rowsColumns = {
    id: { heading: 'Id', size: 100 / 10 },
    reconciled: { heading: 'Reconciled', size: 100 / 10 },
  };

  public allSelected = false;
  public isLoading = 0;
  public showFilters = false;
  public skipQuery = true;

  public endDate = new Date().toISOString().substring(0, 10);

  public vars = {
    filter: {
      categorizationFilter: 'All',
      reconciliationFilter: 'Unreconciled',
      ignoreFilter: 'Unignored',
      walletId: 'All',
      searchTokens: undefined as string[] | undefined,
      errored: undefined as boolean | undefined,
      pivotDate: new Date().toISOString().substring(0, 10),
    },
    limit: '10',
    paginationToken: undefined as string | undefined,
  };

  async mounted() {
    this.isLoading = 1;
    try {
      const url = `${baConfig.getFriendlyApiUrl()}/v2/orgs/${this.orgId}/reconciliations`;
      const resp = await axios.get(url, { withCredentials: true });
      this.reconciliations = resp.data.items
        .map((m: any) => {
          return {
            key: m.id,
            value: m.name,
          };
        })
        .sort((a: any, b: any) => (a.value ?? '').localeCompare(b.value ?? '', undefined, { sensitivity: 'base' }));
    } finally {
      this.isLoading = 0;
    }
  }

  public friendlyStatus(status: string) {
    switch (status) {
      case 'InProgress':
        return 'Reconciliation In Progress';
      case 'Loading':
        return 'Data Loading';
      default:
        return 'Unknown';
    }
  }

  async run() {
    this.isLoading = 1;
    try {
      const url = `${baConfig.getFriendlyApiUrl()}/v2/orgs/${this.orgId}/reconciliations/${this.reconciliation}/runs`;
      const resp = await axios.post(url, {}, { withCredentials: true });
      this.reconciliations = resp.data.items.map((m: any) => {
        return {
          key: m.id,
          value: m.name,
        };
      });

      await this.loadRuns();
    } finally {
      this.isLoading = 0;
    }
  }

  public async markReconciled(row: any) {
    row.isLoading = true;
    try {
      const url = `${baConfig.getFriendlyApiUrl()}/v2/orgs/${this.orgId}/reconciliations/${this.reconciliation}/runs/${
        this.runId
      }/rows/${row.id}`;
      const u = {
        reconciled: !row.reconciled,
      };
      const resp = await axios.put(url, { withCredentials: true });
    } finally {
      row.reconciled = !row.reconciled;
      row.isLoading = false;
    }
  }

  public getVarianceClass(c: any) {
    if (c.variance === 'none') {
      return 'tw-bg-green-50';
    } else if (c.variance === 'near-match') {
      return 'tw-bg-yellow-100';
    } else {
      return 'tw-bg-red-100';
    }
  }

  public getRowVarianceClass(row: any) {
    if (row.variance === 'none' || row.variance === 'near-match') {
      return 'tw-bg-green-50';
    } else {
      return 'tw-bg-red-100';
    }
  }

  async viewRun(id: string) {
    this.isLoading = 1;
    this.showRuns = false;
    this.runId = id;
    try {
      const url = `${baConfig.getFriendlyApiUrl()}/v2/orgs/${this.orgId}/reconciliations/${
        this.reconciliation
      }/runs/${id}/rows`;
      const resp = await axios.get(url, { withCredentials: true });
      this.rows = resp.data.items;
      if (this.rows) {
        if (this.rows.length > 0) {
          for (const c of this.rows[0].comparisons) {
            (this.rowsColumns as any)[c.name as string] = { heading: c.name, size: 100 / 20 };
          }
        }
      }
    } finally {
      this.isLoading = 0;
    }
  }

  @Watch('reconciliation')
  async loadRuns() {
    this.isLoading = 1;
    try {
      const url = `${baConfig.getFriendlyApiUrl()}/v2/orgs/${this.orgId}/reconciliations/${this.reconciliation}/runs`;
      const resp = await axios.get(url, { withCredentials: true });
      this.runs = resp.data.items.sort((a: any, b: any) => (b.createdSEC ?? 0) - (a.createdSEC ?? 0));
    } finally {
      this.isLoading = 0;
    }
  }

  public showMenuOn: Transaction | null = null;
  public expandedTxn: Transaction | null = null;
  public showCreateManualTxnModal = false;
  public ReconciliationStatus = ReconciliationStatus;
  public txnToDelete: Transaction | null = null;
  public deleteDialog = false;
  public isSoftLoading = 0;
  public walletId = 'select';
  public ticker: string | null = null;

  public get categories() {
    return this.$store.getters['categories/ENABLE_CATEGORIES'];
  }

  public get contacts(): Contact[] {
    return this.$store.getters['contacts/ENABLED_CONTACTS'];
  }

  public async refresh() {
    await Promise.all([this.$apollo.queries.register.refetch()]);

    this.$store.dispatch('categories/getCategories', this.$store.state.currentOrg.id);
    this.$store.dispatch('contacts/getContacts', this.$store.state.currentOrg.id);
    this.$store.dispatch('wallets/getWallets', this.$store.state.currentOrg.id);
  }

  toRounded(valStr: string, decimals: number) {
    const fixedString = Number(valStr).toFixed(decimals);
    return Number(fixedString);
  }
}
